// THIS FILE IS AUTO GENERATED
var GenIcon = require('../lib').GenIcon
module.exports.IoPlaySkipForwardSharp = function IoPlaySkipForwardSharp (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M368.53 64v163.52L96 64v384l272.53-163.52V448H416V64h-47.47z"},"child":[]}]})(props);
};
